/**
 * createTime: 2018-12-18
 * author: wuxiangyu
 * decoration: 门店商城 shopping
 * 1.处理金额计算精确到**位小数-computePrice(金额，位数)
 * 2.按照订单状态显示对应的系统提示systemNews(状态，接口数据)  状态码：1待审核 2待付款 3待发货 4待收货 5已完成 6已取消 7已关闭 8售后中
 * 
 *  */
export default {
  computePrice(price, digit) {
    let digits = parseInt(digit);
    let DISITS_NUM = 1;
    for (let i = 0; i < digits + 1; i++) {
      price = price * 10;
      DISITS_NUM = DISITS_NUM * 10;
    }
    price = Math.round(price) / DISITS_NUM;
    price = price.toFixed(digit);
    return price;
  },
  systemNews(status, val, orderType) {
    console.log(status)
    let NOTICE = '';
    if (orderType == 3) {
      if (status == 3) {
        NOTICE = '补发订单已申请成功，请耐心等待哦';
      } else if (status == 4) {
        NOTICE = '补发订单已发出';
      } else if (status == 5) {
        NOTICE = '补发订单已完成，欢迎下次选购';
      }
    } else if (orderType == 4) {
      if (status == 3) {
        NOTICE = '您的退货单以生成，请尽快退货';
      } else if (status == 4) {
        NOTICE = '退货信息已确认，感谢您的配合';
      } else if (status == 5) {
        NOTICE = '退货已完成，感谢您的配合';
      }
    } else {
      if (status == 1) {
        NOTICE = '订单已提交成功，请耐心等待市场管理专员审核';
      }  else if (status == 2) {
        NOTICE = '订单已审核通过，财务即将划扣款项或等待大款，请及时关注消息通知';
      } else if (status == 3) {
        NOTICE = '订单付款成功，预计24小时内发货，请耐心等待哦';
      } else if (status == 4) {
        NOTICE = val;
      } else if (status == 5) {
        NOTICE = '订单已签收，欢迎再次下单';
      } else if (status == 6) {
        NOTICE = '订单已关闭，原因：' + val;
      } else if (status == 7) {
        NOTICE = '订单已取消';
      } else if (status == 8) {
        NOTICE = '售后申请已提交，请等待管理专员的处理';
      } else if (status == 9) {
        NOTICE = '售后申请已处理';
      } else if (status == 10) {
        NOTICE = '售后申请已拒绝，拒绝原因：' + val;
      } else {
        NOTICE = '';
      }
    }

    return NOTICE;
  }

}


// WEBPACK FOOTER //
// ./src/assets/js/shoppingPublic.js